import React, { Component } from 'react'
import {
    BrowserRouter as Router,
    Route
} from 'react-router-dom'
import {
    WrappedLogin,
    MyOb1,
    Summary,
    Feedback_myself,
    Feedback_all,
    Feedbackdetail,
    Feedback_new,
    UserMD,
    Newobservation_Basic_Info,
    Newobservation_Checklist,
    Newobservation_Category,
    Newobservation_Action,
    Newobservation_Summary,
    Profile,
    Myself,
    Organization,
    SOTarget,
    Company,
    All,
    ObserveType,
    Y2DObseveType,
    Y2DJobType,
    AboutUs,
    SOHandbook,
    Companyadmin,
    Manual,
    JobTypeMaster,
    CategoryMaster,
    RootCauseMaster,
    Capa,
    CapaAssignee,
    CapaManager
} from '../app'
import { PrivateRoute, PrivateRoute_Admin, PrivateRouteWithParams } from './privateroute'
import { connect } from 'react-redux'

//Multi-Language
import AppLocale from '../lngProvider';
import { IntlProvider } from 'react-intl';

import ObservationRequest from "../app/routes/Observation/Request/ObservationRequest";
import ObservationRequestCSM from "../app/routes/ObservationCSM/Request/ObservationRequest";
import SOTEditData from "../app/routes/systemmanagement/SOTEditData/SOTEditData";
import SOTEditDataCSM from "../app/routes/systemmanagement/SOTEditDataCSM/SOTEditDataCSM";
import CapaManagerCSM from "../app/routes/CapaManagerCSM/CapaManagerCSM";
import CapaCSM from "../app/routes/CapaCSM/CapaCSM";

import { includes, split, last } from 'lodash';
import Feedback_all_csm from '../app/routes/feedback/Feedback_all_csm'
import Feedbackdetail_csm from '../app/routes/feedback/Feedbackdetail_csm'

class App extends Component {

    componentWillMount() {
        //let session_expired = localStorage.getItem('session_expired')
        //let expired = new Date(session_expired)
        //if (expired < new Date()) {
        //    localStorage.clear();
        //}

        if (!localStorage.getItem("authen")) {
            if (includes(window.location.pathname, "observation/req-from-tag/")) {
                const tagNo = last(split(window.location.pathname, "/"));
                localStorage.setItem("ObsReqFromTag", tagNo);

            }
        }
    }

    render() {

        console.debug("App.render()", {
            props: this.props,
            state: this.state
        });

        const { locale } = this.props.setting
        const currentAppLocale = AppLocale[locale.locale];
        // console.log(locale.locale)
        return (
            <IntlProvider
                locale={currentAppLocale.locale}
                messages={currentAppLocale.messages}
            >
                <Router >
                    <div>
                        <Route path="/signin" component={WrappedLogin} />
                        <PrivateRoute exact path="/" component={Profile} />
                        <PrivateRoute path="/observation/request" component={ObservationRequest} exact={true} />
                        <PrivateRoute path="/observation/req-from-tag/:tagno" component={ObservationRequest} exact={true} />
                        <PrivateRoute path="/observation/request/:id" component={ObservationRequest} exact={true} />
                        <PrivateRoute path="/observation/request/:id/:viewstate" component={ObservationRequest} exact={true} />
                        <PrivateRoute path="/observation-csm/request/:id" component={ObservationRequestCSM} exact={true} />
                        <PrivateRoute path="/observation-csm/request/:id/:viewstate" component={ObservationRequestCSM} exact={true} />
                        <PrivateRoute path="/newobservation_basic_info" component={Newobservation_Basic_Info} />
                        <PrivateRoute path="/newobservation_checklist" component={Newobservation_Checklist} />
                        <PrivateRoute path="/newobservation/category" component={Newobservation_Category} />
                        <PrivateRoute path="/newobservation_action" component={Newobservation_Action} />
                        <PrivateRoute path="/newobservation_summary" component={Newobservation_Summary} />
                        <PrivateRoute path="/dashboard_myself" component={Myself} />
                        <PrivateRoute path="/DepartmentDashboard" component={Organization} />
                        <PrivateRoute path="/SOParticipation" component={SOTarget} />
                        <PrivateRoute path="/CompanyDashboard" component={Company} />
                        <PrivateRoute path="/dashboard_SCG" component={All} />
                        <PrivateRoute path="/dashboard/observetype" component={ObserveType} />
                        <PrivateRoute path="/dashboard/Y2DObseveType" component={Y2DObseveType} />
                        <PrivateRoute path="/dashboard/Y2DJobType" component={Y2DJobType} />
                        <PrivateRoute path="/about_us" component={AboutUs} />
                        <PrivateRoute path="/myobservation" component={MyOb1} />
                        <PrivateRoute path="/summary" component={Summary} />
                        <PrivateRoute path="/capa/:id" component={Capa} />
                        <PrivateRoute path="/capa_csm/:id" component={CapaCSM} />
                        <PrivateRoute path="/capa_assignee" component={CapaAssignee} />
                        <PrivateRoute path="/capa_manager" component={CapaManager} />
                        <PrivateRoute path="/capa_manager_csm" component={CapaManagerCSM} />
                        <PrivateRoute path="/feedback_myself" component={Feedback_myself} />
                        <PrivateRoute path="/feedback_all" component={Feedback_all} />
                        <PrivateRoute path="/feedback_all_csm" component={Feedback_all_csm} />
                        <PrivateRoute path="/feedbackdetail" component={Feedbackdetail} />
                        <PrivateRoute path="/feedbackdetail_csm" component={Feedbackdetail_csm} />
                        <PrivateRoute path="/newfeedback" component={Feedback_new} />
                        <PrivateRoute path="/SOHandbook" component={SOHandbook} />
                        <PrivateRoute path="/Companyadmin" component={Companyadmin} />
                        <PrivateRoute_Admin path="/master_jobtype" component={JobTypeMaster} />
                        <PrivateRoute_Admin path="/master_category" component={CategoryMaster} />
                        <PrivateRoute_Admin path="/master_rootcause" component={RootCauseMaster} />
                        <PrivateRoute exact path="/manual" component={Manual} />
                        <PrivateRoute_Admin path="/usermd" component={UserMD} />
                        <PrivateRoute path="/setting_sot_editdata" component={SOTEditData} />
                        <PrivateRoute path="/setting_sot_editdata_csm" component={SOTEditDataCSM} />
                    </div>
                </Router>
            </IntlProvider>
        );
    }
}

const mapStatetoProps = (state) => {
    return {
        setting: state.setting,
    }
}
export default connect(mapStatetoProps)(App)